// ##### 25-02-05 Komarov
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-14
const SearchResultsHeader = () => {
  // ##### Komarov 2025-08-05
  const SearchResults = useLocalizedText('SearchResults');
  return (
    <div data-component="SearchResultsHeader">
      <h3 className="SearchResults">
        {
          // ##### 23-10-04 Komarov
          SearchResults
        }
      </h3>
    </div>
  );
};

// ##### 25-05-21 Komarov
export default SearchResultsHeader;
